import { createTheme } from "@mui/material";
export const getMuiTheme = (overrides = {}) =>
    createTheme({
        components: {
            MuiTableSortLabel: {
                styleOverrides: {
                    root: {
                        '& .MuiTableSortLabel-icon': {
                            display: 'none !important', // Hide default icon
                        },
                        '&.Mui-active .MuiTableSortLabel-iconDirectionAsc': {
                            backgroundImage: 'url(/admin-images/new_bottom_arrow_icon3.svg) !important',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            display: 'block !important',
                            backgroundColor: 'transparent',
                            border: 'none',
                        },
                        '&.Mui-active .MuiTableSortLabel-iconDirectionDesc': {
                            backgroundImage: 'url(/admin-images/new_bottom_arrow_icon3.svg) !important',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            display: 'block !important',
                            backgroundColor: 'transparent',
                            border: 'none',
                        },
                    },
                },
            },
            MUIDataTableToolbar: {
                    styleOverrides: {
                        filterPaper: {
                            width: "450px",
                            marginTop: "20px",
                            marginRight: "20px"
                        },
                },
            },
            MUIDataTableFilterList: {
                styleOverrides: {
                  root: {
                    marginBottom: 10
                  },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    head: {
                        '&:last-child': {
                          position: 'sticky',
                          right: 0,
                          zIndex: 1201,
                          backgroundColor: '#fff',
                        },
                    },
                    root: {
                        backgroundColor: "#ffff",
                    },
                },
            },
            MuiList: {
                styleOverrides: {
                  root: {
                    maxHeight: "300px"
                  },
                },
              },
              MuiToolbar: {
                styleOverrides: {
                  root: {
                    padding: '0px!important',
                    backgroundColor: "transparent",
                    alignItems: "flex-start",
                    minHeight: '48px !important'
                  },
                },
            },
            ...overrides,
        },
    });